import React from 'react';
import DriversEmergency from '@loggi/drivers-emergency';
import { useHistory } from 'react-router-dom';

export const companyRelation = {
  collaborator: 'DRIVER_COMPANY_RELATION_COLLABORATOR',
  contractor: 'DRIVER_COMPANY_RELATION_CONTRACTOR',
  staff: 'DRIVER_COMPANY_RELATION_STAFF'
};

export default function EmergencyWrapper() {
  const history = useHistory();

  return <DriversEmergency goBack={() => history.goBack()} />;
}
